import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ReportsDefaultPage from 'Features/Reports/Reports.DefaultPage';
import ReportRouteCheck from 'Features/Reports/Report.RouteCheck';
import Reports from 'Features/Reports/Reports';
import { useGetAllMeteoCodesQuery } from 'Services/api/meteoCodesApi';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import ReportForm from './Report.Form';
import ReportProvider from './Report.Context';

// TODO
// итого список роутов, который нужен:

// / - здесь показываем DefaultPage

// form/*
//  new - здесь показываем форму создания отчета
//  :reportId - здесь показываем форму редактирования конкретного отчета

// :reportId/*
//  / - здесь показываем отчет в табличном виде
//  /graph - здесь показываем отчет в виде графиков

// для этого подхода, есть проблема с sidebar'ом, надо ли подсвечивать отчет при редактировании?
// или сделать финт ушами и не показывать sidebar

function ReportsRouter() {
  const { isFetching: isMeteocodesFetching } = useGetAllMeteoCodesQuery();

  if (isMeteocodesFetching) return <SuspenseSpinner />;

  return (
    <ReportProvider>
      <Routes>
        <Route path="/" element={<Reports />}>
          <Route path="/" element={<ReportsDefaultPage />} />
          <Route path="new" element={<ReportForm isNew />} />
          <Route path=":reportId/*" element={<ReportRouteCheck />} />
        </Route>
      </Routes>
    </ReportProvider>
  );
}

export default ReportsRouter;
